module.exports = __webpack_public_path__ + "static/img/90-3.29cf9ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/90-3.jpg
// module id = zsk1
// module chunks = 0